/**
 * The parsed callback here is used to ensure that the DOM is parsed before
 * running queries on the DOM.
 *
 * Chrome does not guarantee that children are already parsed when a HTMLElement
 * is mounted and connectedCallback is triggered (when the JavaScript is
 * located in <body> of the page).
 * When the children are not parsed we cannot run DOM queries against the
 * children and they always result in an empty result, e.g.:
 *
 *   el.querySelectorAll('.some-child') => []
 *
 * @see: https://stackoverflow.com/a/52884370/831465
 *
 * To be able to execute code when the children DOM parse is complete we use
 * the `html-parsed-element` package.
 * It provides a reliable `parsedCallback` method that is called once the
 * parsing is complete.
 *
 * @see: https://github.com/WebReflection/html-parsed-element
 */

export class HTMLParsedChildrenElement extends HTMLElement {
  childrenParsed = false;

  parsedCallback() {
    this.childrenParsed = true;
  }
}
